import React, { useState, useEffect } from "react";
import {
    TextField,
    Button,
    IconButton,
    Typography,
    Box,
    FormControl,
    InputLabel,
    OutlinedInput,
    InputAdornment,
    Stack,
    useThemeProps,
} from "@mui/material";
import Logo from "../../assets/images/common/chat-logo.png";
import { useTheme } from '@mui/material/styles';
import { Newchat, Dropdown, Gemini, Chatlike, Chatdislike, Chatrefresh, Chatcopy, Sendmessege, Modalclose } from '../../icons/icons';
import Link from '@mui/material/Link';
import Autocomplete from '@mui/material/Autocomplete';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Grid from '@mui/material/Grid2';
import { useDispatch, useSelector } from "react-redux";
import { ModelSelection } from "../../redux/chatslice";

// import Menu from '@mui/material/Menu';
// import MenuItem from '@mui/material/MenuItem';




function Header() {
    const theme = useTheme();
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    return (
        <>
            <Stack direction={'row'} justifyContent={'space-between'} alignItems={'center'} sx={{ p: { xs: '18px', sm: "20px  32px" }, borderBottom: "1px solid", borderBottomColor: '#0A43AE', background: theme.palette.primary.primary1, }}>

                <Box>
                    <img src={Logo} alt="logo" />
                </Box>
                <Stack direction={'row'}>

                    <Box>
                        <Stack direction={'row'} alignItems={"center"} id="basic-button"
                            sx={{
                                position: 'relative',
                                p: '10px 20px',
                                cursor: 'pointer',
                                background: theme.palette.primary.morelight, borderRadius: '50px'
                            }}>
                            <Typography variant="p" sx={{ color: theme.palette.secondary.main, fontWeight: '700', fontSize: '16px', mr: '10px' }} fullWidth>
                                Models
                            </Typography>
                            <Dropdown />
                            <Box sx={{
                                position: 'absolute',
                                top: '-2px', right: '-2px',
                                width: '18px', height: '18px', fontSize: '14px', fontWeight: '700', background: "#FF0000", borderRadius: '50%', color: theme.palette.white.white, display: 'flex', justifyContent: 'center', alignItems: 'center'
                            }}>
                                4
                            </Box>
                        </Stack>
                    </Box>

                    <Button direction={'row'} justifyContent={'center'} alignItems={'center'} sx={{ width: '40px', height: '40px', textAlign: 'center', borderRadius: '50%', fontSize: '18px', fontWeight: '700', color: theme.palette.white.white, background: theme.palette.primary.main, cursor: 'pointer', ml: '24px', minWidth: '40px' }}
                        aria-controls={open ? 'basic-menu' : undefined}
                        aria-haspopup="true"
                        aria-expanded={open ? 'true' : undefined}
                        onClick={handleClick}>
                        T
                    </Button>


                    <Menu
                        id="basic-menu"
                        anchorEl={anchorEl}
                        open={open}
                        onClose={handleClose}
                        MenuListProps={{
                            'aria-labelledby': 'basic-button',
                        }}
                    >
                        <MenuItem onClick={handleClose}>My Account</MenuItem>
                        <MenuItem onClick={handleClose}>My Wallet</MenuItem>

                    </Menu>

                </Stack>


            </Stack>
        </>
    );
}

export default Header;
